export const Errors = {
  // G
  GLOBAL: {
    // W
    WEB3: {
      // 0
      REJECTED: {
        code: "GW0",
        message: "You rejected the transaction.",
      },

      // 1 — last resort only; prefer a more specific GW code when possible
      UNKNOWN: {
        code: "GW1",
        message: "The transaction failed. Try again.",
      },

      // 2
      APPROVE_FAILED: {
        code: "GW2",
        message: "Token approval failed. Try again.",
      },

      // 3
      INSUFFICIENT_FUNDS: {
        code: "GW3",
        message:
          "Not enough {token} in your wallet to cover gas for this transaction.",
      },

      // 4
      CONTRACT_REVERTED: {
        code: "GW4",
        message: "{reason}",
      },

      // 5
      TX_REVERTED: {
        code: "GW5",
        message:
          "The transaction reverted on-chain. You were not charged beyond gas.",
      },

      // 6
      NETWORK: {
        code: "GW6",
        message: "Network error. Check your connection and try again.",
      },

      // 7
      WRONG_NETWORK: {
        code: "GW7",
        message: "Wrong network. Switch chain in your wallet and try again.",
      },

      // 8
      NONCE: {
        code: "GW8",
        message:
          "A previous transaction is still pending. Wait for it, or reset the account in your wallet.",
      },

      // 9
      OUT_OF_GAS: {
        code: "GW9",
        message: "Out of gas. Try again, or raise the gas limit in your wallet.",
      },
    },

    // A
    ACCOUNT: {
      // 0
      NOT_CONNECTED: {
        code: "GA0",
        message: "Connect your wallet first.",
      },
      // 1
      SIGNING_FAILED: {
        code: "GA1",
        message: "Wallet signature failed. Try again.",
      },
    },

    // T
    TOKEN: {
      // 0
      CLIPBOARD_FAILED: {
        code: "WT0",
        message: "Couldn't copy the address.",
      },
    },

    // P
    PROFILE: {
      // 0
      CREATION_FAILED: {
        code: "GP0",
        message: "Couldn't create your profile. Try again.",
      },
      // 1
      NOT_CREATED: {
        code: "GP1",
        message: "Create a profile before doing this.",
      },

      // 2
      DESCRIPTION_EDIT_FAILED: {
        code: "GP2",
        message: "Couldn't update your profile description.",
      },

      // 3
      INVENTORY_DISPLAY_SETTING_FAILED: {
        code: "GP3",
        message: "Couldn't update inventory display.",
      },

      // 4
      CLAIMING_KEY_FAILED: {
        code: "GP4",
        message: "Couldn't claim the key.",
      },

      // 5
      GETTING_FAILED: {
        code: "GP5",
        message: "Couldn't load this profile.",
      },

      // 6
      PREMIUM_ALREADY_ACTIVE: {
        code: "GP6",
        message: "Premium is already active.",
      },

      // 7
      NOT_ENOUGH_KEYS: {
        code: "GP7",
        message: "You don't have enough keys.",
      },

      // 8
      UPLOAD_AVATAR_FAILED: {
        code: "GP8",
        message: "Couldn't upload the avatar. Check the image and try again.",
      },

      // 9
      UPLOAD_BACKGROUND_FAILED: {
        code: "GP9",
        message:
          "Couldn't upload the background. Check the image and try again.",
      },
    },
  },

  // F
  FAMILY: {
    // C
    CAPO_REGIME: {
      //0
      UPDATE_MEMBER_FAILED: {
        code: "FC0",
        message: "Couldn't update this member's capo regime.",
      },
    },
    // I
    INVITE: {
      // 0
      LIMIT_EXCEEDED: {
        code: "FI0",
        message: "Invite limit reached. Try again later.",
      },
      // 1
      INVITED_FAILED: {
        code: "FI1",
        message: "Couldn't send the invite.",
      },
    },
    // V
    VALIDATE: {
      // 0
      EMPTY_NAME: {
        code: "FV0",
        message: "Enter a family name.",
      },
      // 1
      NOT_UPPERCASE: {
        code: "FV1",
        message: "Family name can't be all uppercase.",
      },
      // 2
      IS_IN_FAMILY: {
        code: "FV2",
        message: "You're already in a family.",
      },
      // 3
      CREATING_FAILED: {
        code: "FV3",
        message: "Couldn't create the family. Try again.",
      },
      // 4
      LEAVING_FAILED: {
        code: "FV4",
        message: "Couldn't leave the family.",
      },
      // 5
      KICKING_FAILED: {
        code: "FV5",
        message: "Couldn't kick this member.",
      },
      // 6
      INVALID_IMAGE: {
        code: "FV6",
        message: "That image file isn't valid.",
      },
      // 7
      UPDATE_LEAVE_FEE_FAILED: {
        code: "FV7",
        message: "Couldn't update the leave fee.",
      },
    },
    // N
    INVENTORY: {
      // 0
      TRANSFER_FAILED: {
        code: "FN0",
        message: "Couldn't transfer the item.",
      },
      // 1
      AMOUNT_INVALID: {
        code: "FN1",
        message: "Enter a valid NFT key amount.",
      },
      // 2
      NFT_TRANSFER_FAILED: {
        code: "FN2",
        message: "Couldn't transfer the NFT key.",
      },
      // 3
      NOT_ENOUGH_NFT: {
        code: "FN3",
        message: "You only have {ogNFTBalance} OG NFTs.",
      },
      // 4
      NFT_AMOUNT_INVALID: {
        code: "FN4",
        message: "Enter a valid OG NFT amount.",
      },
      // 5
      OG_NFT_TRANSFER_FAILED: {
        code: "FN5",
        message: "Couldn't transfer the OG NFT.",
      },
      // 6
      DEPOSIT_NFT_FAILED: {
        code: "FN6",
        message: "Couldn't deposit the NFT key.",
      },
      // 7
      DEPOSIT_OG_NFT_FAILED: {
        code: "FN7",
        message: "Couldn't deposit the OG NFT.",
      },
      // 8
      WITHDRAW_NFT_FAILED: {
        code: "FN8",
        message: "Couldn't withdraw the NFT key.",
      },
      // 9
      WITHDRAW_OG_NFT_FAILED: {
        code: "FN9",
        message: "Couldn't withdraw the OG NFT.",
      },
      // 10
      UNWRAP_GAMEKEY_FAILED: {
        code: "FN10",
        message: "Couldn't unwrap the game key.",
      },
      // 11
      UNWRAP_MAFIA_ITEM_FAILED: {
        code: "FN11",
        message: "Couldn't unwrap the MAFIA item.",
      },
      // 12
      UNWRAP_OG_NFT_FAILED: {
        code: "FN12",
        message: "Couldn't unwrap the OG NFT.",
      },
      // 13
      BUY_PREMIUM_FAILED: {
        code: "FN13",
        message: "Couldn't buy premium.",
      },
      // 14
      OPEN_CRATE_FAILED: {
        code: "FN14",
        message: "Couldn't open the crate with your NFT key.",
      },

      // 15
      FINISH_NFT_CRATE: {
        code: "FN15",
        message: "Couldn't finish using the NFT key.",
      },
    },
  },

  // M
  MARKET: {
    // B
    BASIC: {
      // 0
      NEXT_BID_AMOUNT_INVALID: {
        code: "MB0",
        message: "Your bid must be higher than the current bid.",
      },

      // 1
      NOT_SELECTED_ITEM: {
        code: "MB1",
        message: "Select an item to list.",
      },

      // 2
      USD_INVALID: {
        code: "MB2",
        message: "Enter a valid USD amount.",
      },

      // 3
      DURATION_INVALID: {
        code: "MB3",
        message: "Select a listing duration.",
      },

      // 4
      REJECTED_AUCTION: {
        code: "MB4",
        message: "Couldn't complete the auction.",
      },

      // 5
      REJECTED_BID: {
        code: "MB5",
        message: "Couldn't place the bid.",
      },

      INSUFFICIENT_BID: {
        code: "MB6",
        message: "Bid is too low. Increase the amount.",
      },
    },
  },

  // V
  Vault: {
    // B
    BASIC: {
      // 0
      CONVERT_FAILED: {
        code: "VB0",
        message: "Couldn't convert $MAFIA to {chain}.",
      },
    },
  },

  // E
  EXCHANGE: {
    CONVERT: {
      ITEM_NOT_SELECTED: {
        code: "EC0",
        message: "Select items to convert.",
      },
    },

    OTC: {
      TRADE_ITEM_NOT_SELECTED: {
        code: "EO0",
        message: "Select the item to offer.",
      },
      OPTION_ITEM_NOT_SELECTED: {
        code: "EO1",
        message: "Select the item you want.",
      },
      MAXIMUM_FIVE_ITEMS: {
        code: "E02",
        message: "You can request at most 5 items.",
      },
    },

    DEPOSIT: {
      FAILED_ADD_LIQUIDITY: {
        code: "ED0",
        message: "Couldn't add liquidity.",
      },
      Cash_MORE_DEPOSIT: {
        code: "ED1",
        message: "Cash must be greater than the deposit amount.",
      },
      INPUT_CASH: {
        code: "ED2",
        message: "Enter a cash amount.",
      },
      FAILED_REMOVE_LIQUIDITY: {
        code: "ED3",
        message: "Couldn't remove this liquidity.",
      },
    },

    SWAP: {
      INPUT_TOKEN_AMOUNT: {
        code: "ES0",
        message: "Enter an amount to sell.",
      },
      NOT_ENOUGH_BALANCE: {
        code: "ES1",
        message: "Not enough balance for this swap.",
      },
      INSUFFICIENT_LP: {
        code: "ES2",
        message: "Not enough liquidity for this swap.",
      },
    },
  },

  DAO: {
    VOTE: {
      VOTE_FAILED: {
        code: "VD0",
        message: "Couldn't cast your vote.",
      },

      AMOUNT_FAILED: {
        code: "VD1",
        message: "Deposit $MAFIA before voting.",
      },
    },

    CREATE: {
      CREATE_FAILED: {
        code: "VC0",
        message: "Couldn't create the proposal.",
      },

      DURATION_INVALID: {
        code: "VC1",
        message: "Enter a valid vote duration.",
      },

      OPTIONS_INVALID: {
        code: "VC2",
        message: "Add valid voting options.",
      },

      EMPTY_OPTION: {
        code: "VC3",
        message: "Add at least one option.",
      },
    },

    OPEN: {
      OPEN_FAILED: {
        code: "VO0",
        message: "Couldn't open this proposal.",
      },
    },
  },

  ROULETTE: {
    BET: {
      NOT_REQUESTED: {
        code: "RB0",
        message: "Place a bet first.",
      },
    },
  },

  SLOT: {
    BET: {
      NOT_REQUESTED: {
        code: "SB0",
        message: "Place a bet first.",
      },
    },
  },
  RACING: {
    // C
    CREATE: {
      // 0
      INVALID_CAR: {
        code: "RC0",
        message: "Select a car.",
      },
      INVALID_CASH_AMOUNT: {
        code: "RC1",
        message: "Enter a valid cash amount.",
      },
      INVALID_WINNER_PRIZE: {
        code: "RC2",
        message: "Select a prize type.",
      },

      CASH_AMOUNT_EXCEED: {
        code: "RC3",
        message: "Not enough cash for this race.",
      },
    },

    JOIN: {
      NOT_IN_SAME_CITY: {
        code: "RJ0",
        message: "You must be in the same city to join.",
      },
    },
  },

  PERK: {
    OPEN_PERK_BOX_FAILED: {
      code: "PP0",
      message: "Couldn't open the perk box.",
    },

    FINISH_OPEN_PERK_BOX_FAILED: {
      code: "PP1",
      message: "Couldn't finish opening the perk box.",
    },

    NOT_ENOUGH_MAFIA: {
      code: "PP2",
      message: "Not enough $MAFIA to activate this perk.",
    },

    NO_AVAILABLE_SLOT: {
      code: "PP3",
      message: "No free perk slot. Cancel one first.",
    },

    CANCEL_PERK_FAILED: {
      code: "PP4",
      message: "Couldn't cancel this perk.",
    },

    PERK_ALREADY_ACTIVATED: {
      code: "PP5",
      message: "A perk in this category is already active.",
    },

    PERK_AMOUNT_EXCEED: {
      code: "PP6",
      message: "Enter a valid perk amount to transfer.",
    },
  },

  JACKPOT: {
    INVALID_AMOUNT: {
      code: "JACKPOT_001",
      message: "Enter a valid bet amount.",
    },
    INSUFFICIENT_BALANCE: {
      code: "JACKPOT_002",
      message: "Not enough balance to enter.",
    },
    MIN_BET_ERROR: {
      code: "JACKPOT_006",
      message: "Minimum bet is ${minBet}.",
    },
    MAX_BET_ERROR: {
      code: "JACKPOT_007",
      message: "Maximum bet is ${maxBet}.",
    },
    BET_LIMITS_VALIDATION_FAILED: {
      code: "JACKPOT_008",
      message: "Couldn't check bet limits.",
    },
    ENTER_JACKPOT_FAILED: {
      code: "JACKPOT_005",
      message: "Couldn't enter the jackpot.",
    },
    ENTER_WITH_PERK_BOXES_FAILED: {
      code: "JACKPOT_004",
      message: "Couldn't enter with perk boxes.",
    },
    WALLET_NOT_CONNECTED: {
      code: "JACKPOT_009",
      message: "Connect your wallet first.",
    },
    INVALID_ADDRESS: {
      code: "JACKPOT_010",
      message: "Enter a valid wallet address.",
    },
    BET_LIMITS_UPDATE_FAILED: {
      code: "JACKPOT_011",
      message: "Couldn't update bet limits.",
    },
    OWNER_TRANSFER_FAILED: {
      code: "JACKPOT_012",
      message: "Couldn't transfer ownership.",
    },
    VALIDATION_ERROR: {
      code: "JACKPOT_013",
      message: "Validation error: {message}",
    },
    INVALID_ITEM: {
      code: "JACKPOT_014",
      message: "Select an item.",
    },
    ENTER_WITH_INVENTORY_ITEM_FAILED: {
      code: "JACKPOT_015",
      message: "Couldn't enter with that item.",
    },
  },

  BODYGUARD: {
    TRAINING: {
      MAX_LEVEL_REACHED: {
        code: "BT0",
        message: "This bodyguard is already at max level.",
      },
      NO_AVAILABLE_SLOTS: {
        code: "BT1",
        message: "All training slots are busy. Wait for one to finish.",
      },
      INSUFFICIENT_BALANCE: {
        code: "BT2",
        message: "Not enough in-game cash for training.",
      },
      COST_FETCH_FAILED: {
        code: "BT5",
        message: "Couldn't load the training cost. Try again.",
      },
    },
    TRANSFER: {
      PLAYER_NOT_FOUND: {
        code: "BT3",
        message: "No player found with that name.",
      },
      CANNOT_TRANSFER_TO_SELF: {
        code: "BT4",
        message: "You can't transfer to yourself.",
      },
    },
  },

  GAME_INTELLIGENCE: {
    NOT_ENOUGH_CREDITS: {
      code: "GI0",
      message: "Not enough GI credits.",
    },
    NOT_ENOUGH_ALLOWANCE: {
      code: "GI1",
      message: "Approve more GI credits first.",
    },
    REQUEST_FAILED: {
      code: "GI2",
      message: "Couldn't send the Game Intelligence request.",
    },
    IN_JAIL: {
      code: "GI3",
      message: "You can't request intelligence while in jail.",
    },
  },

  PREMIUM: {
    SUBSCRIBE_FAILED: {
      code: "GP0",
      message: "Couldn't start the subscription.",
    },
  },

  REBIRTH: {
    INSUFFICIENT_BALANCE: {
      code: "RB0",
      message: "Insufficient token balance for this rebirth.",
    },
  },

  RANK_STAKE: {
    // 0
    INVALID_STAKE_AMOUNT: {
      code: "RS0",
      message: "Enter a valid stake amount.",
    },
    // 1
    INSUFFICIENT_BALANCE: {
      code: "RS1",
      message: "Not enough $MAFIA to stake.",
    },
    // 2
    STAKE_FAILED: {
      code: "RS2",
      message: "Couldn't stake $MAFIA.",
    },
    // 3
    UNSTAKE_FAILED: {
      code: "RS3",
      message: "Couldn't unstake $MAFIA.",
    },
    // 4
    ADJUST_STAKE_FAILED: {
      code: "RS4",
      message: "Couldn't update your stake.",
    },
    // 5
    ON_COOLDOWN: {
      code: "RS5",
      message: "Unstake is on cooldown. Wait and try again.",
    },
  },

  SAFEHOUSE: {
    HOURS_INVALID: {
      code: "SH0",
      message: "Enter a stay between {min} and {max} hours.",
    },
    INSUFFICIENT_BALANCE: {
      code: "SH1",
      message: "Not enough in-game cash.",
    },
  },

  BACKFIRE: {
    INITIATOR_NOT_CONFIGURED: {
      code: "BF0",
      message: "Backfire settings are not available on this network yet.",
    },
    SAVE_FAILED: {
      code: "BF1",
      message: "Failed to save backfire settings on-chain. Please try again.",
    },
  },

  KILL_INITIATION: {
    INITIATOR_NOT_CONFIGURED: {
      code: "KI0",
      message: "Kill initiation is not available on this network yet.",
    },
    EXECUTE_FAILED: {
      code: "KI1",
      message: "Failed to initiate the kill on-chain. Please try again.",
    },
    ATTACK_REJECTED: {
      code: "KI2",
      message: "Attack was rejected on-chain.",
    },
  },

  KILL_OUTCOME: {
    KILL_ID_NOT_FOUND: {
      code: "KO0",
      message:
        "Could not find an on-chain kill record for this battle. Try again after the kill transaction confirms.",
    },
    REGISTRY_NOT_CONFIGURED: {
      code: "KO1",
      message: "Kill reward claiming is not available on this network yet.",
    },
    REWARD_CLAIM_FAILED: {
      code: "KO2",
      message:
        "Failed to drain kill rewards. Try again, or drain one asset at a time if the batch is large.",
    },
  },
};
